@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.radioGroupRoot {
  display: flex;
  flex-direction: column;
}

// `all: unset` neutralises the UA button styling on the Radix item, which renders as a <button>.
// It was a bare `button` selector at the top of this file. CSS modules scope CLASS names only, so
// that selector stayed global and shipped `button{all:unset}` into every bundle pulling in
// RadioGroup — including product-plus, where it grew the header betslip button from 40px to 64px
// on /plus in production (NGF-7035). Scoped to the item's own class it does the same job and
// reaches nothing else. Keep top-level selectors in this file class-scoped for the same reason.
.radioGroupItem {
  all: unset;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  border: 1px solid color-mix(in srgb, var(--cxy-color-border-on-color), transparent 50%);

  &[aria-checked='true'] {
    background-color: var(--cxy-color-brand);
    border: 1px solid var(--cxy-color-brand);
  }
}

.radioGroupIndicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;

  &::after {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--cxy-color-surface-primary-default-subtle);
  }
}

.label {
  padding: var(--cxy-spacing-xxsm);
  border-radius: var(--cxy-border-radius-s);

  &:has([data-state='checked']) {
    background-color: color-mix(in srgb, var(--cxy-color-surface-page), transparent 90%);
  }

  @include cxy.screen-size('desktop') {
    @include cxy.font-size('text-m', var(--cxy-fontWeight-normal));
  }
}

[data-fpsm-theme='gazzetta'] {
  .radioGroupItem {
    border: 1px solid var(--cxy-color-border-strong);
  }
  .radioGroupIndicator {
    &::after {
      background-color: var(--cxy-color-surface-default);
    }
  }
}
